/* import __COLOCATED_TEMPLATE__ from './timer.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();